import { render, staticRenderFns } from "./PopupUpdateImgShipping.vue?vue&type=template&id=006a89e3"
import script from "./PopupUpdateImgShipping.vue?vue&type=script&lang=js"
export * from "./PopupUpdateImgShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports